import * as commissionsService from '../../services/voucher/commissions-service';
import { updateLoadedFinancials } from './financial-actions';
import {
  FETCH_TAX_ALLOCATIONS_SUCCESS,
  UPDATE_TAX_ALLOCATION_SUCCESS,
  CREATE_TAX_ALLOCATION_SUCCESS,
  DELETE_TAX_ALLOCATION_SUCCESS,
} from './action-types';

const fetchTaxAllocationsSuccess = taxAllocations => ({
  type: FETCH_TAX_ALLOCATIONS_SUCCESS,
  payload: taxAllocations,
});

const updateTaxAllocationSuccess = taxAllocation => ({
  type: UPDATE_TAX_ALLOCATION_SUCCESS,
  payload: taxAllocation,
});

const createTaxAllocationSuccess = taxAllocation => ({
  type: CREATE_TAX_ALLOCATION_SUCCESS,
  payload: taxAllocation,
});

const deleteTaxAllocationSuccess = id => ({
  type: DELETE_TAX_ALLOCATION_SUCCESS,
  payload: id,
});

const fetchTaxAllocations = params => dispatch => commissionsService.fetchCommissions(params)
  .then(taxAllocations => dispatch(fetchTaxAllocationsSuccess(taxAllocations)))
  .catch(console.error);

const updateTaxAllocation = (id, data, ignoreFinancialUpdate = false) => dispatch => commissionsService.updateCommission(id, data)
  .then((taxAllocation) => {
    dispatch(updateTaxAllocationSuccess(taxAllocation));
    if (!ignoreFinancialUpdate && ('gross_commission' in data || 'voucher_gross_commission_percent' in data)) {
      dispatch(updateLoadedFinancials(taxAllocation.transaction, undefined, 0, {
        force: true,
        skipDealAndTimestampUpdate: true,
      }));
    }
  })
  .catch(console.error);

const createTaxAllocation = params => dispatch => commissionsService.createCommission(params)
  .then(taxAllocation => dispatch(createTaxAllocationSuccess(taxAllocation)))
  .catch(console.error);

const deleteTaxAllocation = id => dispatch => commissionsService.deleteCommission(id)
  .then(() => {
    dispatch(deleteTaxAllocationSuccess(id));
  })
  .catch(console.error);

const deleteTaxAllocationsForDeal = dealId => dispatch => commissionsService.fetchCommissions({
  transaction: dealId,
  payment_group: 5,
})
  .then(taxAllocations => Promise.all(taxAllocations.map(({ id }) => commissionsService.deleteCommission(id)
    .then(() => dispatch(deleteTaxAllocationSuccess(id))))))
  .catch(console.error);

export {
  fetchTaxAllocations,
  updateTaxAllocation,
  createTaxAllocation,
  deleteTaxAllocation,
  deleteTaxAllocationsForDeal,
};
